import noop from '../utils/noop'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

export default class DropdownMenuItem extends PureComponent {
  static propTypes = {
    href: PropTypes.string,
    onClick: PropTypes.func,
    text: PropTypes.string.isRequired
  }

  static defaultProps = {
    onClick: noop
  }

  render() {
    const { text, ...attrs } = this.props

    return (
      <li>
        <a {...attrs}>{text}</a>
      </li>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/DropdownMenuItem.js